import { render } from "./ExcelReferences.vue?vue&type=template&id=6febb7e6"
import script from "./ExcelReferences.vue?vue&type=script&lang=js"
export * from "./ExcelReferences.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__